module.exports = __webpack_public_path__ + "static/media/shipt-logo.57ef33d6.svg";